import { useTranslation } from "react-i18next";
import Modal from "../modal-new";
import copy from "clipboard-copy";
import { truncateText } from "../../utils/string-helpers";

export const ReferralLinkProgram = ({ activeUser }) => {
  const { t } = useTranslation("coaching-portal");
  const { link: referralLink = "" } = activeUser.referralProgramInfo || {};

  return (
    <Modal className="referral-link-modal" title={t("referralLinkProgram.title")}>
      <div className="body">
        <div className="revenue-container">
          <p className="title">{t("referralLinkProgram.shareEarnTitle")}</p>
          <p className="title mt-3 mb-1">
            {t("referralLinkProgram.enjoyingQuestion")}
          </p>
          <p>{t("referralLinkProgram.shareEarnDescription")}</p>
        </div>

        <div className="referral-link-container">
          <p className="title my-3 opacity-70">
            {t("referralLinkProgram.yourReferralLink")}
          </p>
          <div className="link-content">
            <a href={referralLink} target="_blank" rel="noopener noreferrer">
              {truncateText(referralLink, 57)}
            </a>
            <button
              data-button-type="secondary"
              data-icon
              data-icon-only
              onClick={async () => {
                await copy(referralLink);
              }}
            >
              <img src="/img/new-icons/copy.svg" />
            </button>
          </div>
          <p className="italic mb-3 opacity-70">
            {t("referralLinkProgram.copyAndShare")}
          </p>
        </div>
        <BulletContent />
        <p className="title mt-4 opacity-70">
          {t("referralLinkProgram.startSharing")}
        </p>
        <div className="mt-10 mb-8 justify-items-end">
          <a
            className="py-4 px-6 h-auto w-fit"
            target="_blank"
            rel="noopener noreferrer"
            href="https://mystrengthbook.firstpromoter.com/home"
            role="button"
            data-button-type="outline"
          >
            {t("referralLinkProgram.dashboard")}
          </a>
        </div>
      </div>
    </Modal>
  );
};

const BulletContent = () => {
  const { t } = useTranslation("coaching-portal");
  const contentToDisplay = [
    t("referralLinkProgram.bullet1"),
    t("referralLinkProgram.bullet2"),
    t("referralLinkProgram.bullet3"),
  ];

  return (
    <div className="list-container">
      <p className="title mb-1">{t("referralLinkProgram.howItWorks")}</p>
      {contentToDisplay.map((text, index) => (
        <div key={index} className="mb-2">
          <span className="mr-2">{index + 1}.</span>
          <span>{text}</span>
        </div>
      ))}
    </div>
  );
};
